import { useState, useEffect } from 'react'

import { FormResponseStatus } from '../../../models'

const modalBody = 'body'
const modalBodyClass = 'fixed'
const indexDefault = 1

const modalBodyAddClass = () => {
  const $body: any = document.getElementsByTagName(modalBody)
  if($body && $body.length) $body[0].classList.add(modalBodyClass)
}

const modalBodyRemoveClass = () => {
  const $body: any = document.getElementsByTagName(modalBody)
  if($body && $body.length) $body[0].classList.remove(modalBodyClass)
}

const useModal = (showDefault: boolean = false) => {
  const [show, setShow] = useState<boolean>(showDefault)
  const [index, setIndex] = useState<number>(indexDefault)
  const [status, setStatus] = useState<FormResponseStatus>('')
  const [title, setTitle] = useState<string>('')
  const [message, setMessage] = useState<string>('')

  useEffect(() => {
    return () => {
      modalBodyRemoveClass()
    }
  }, [])

  const open = (index = indexDefault) => {
    modalBodyAddClass()
    setShow(true)
    setIndex(index)
  }

  const close = () => {
    modalBodyRemoveClass()
    setShow(false)
  }

  return {
    show,
    open,
    close,
    index,
    setIndex,
    message,
    setMessage,
    title,
    setTitle,
    status,
    setStatus
  }
}

export { useModal }